<template>
    <div class="school-year-setting">
        <avue-crud 
            :data="xndata" 
            :option="xnoption" 
            v-model="xnobj" 
            @row-save="rowSave" 
            @row-update="rowUpdate"
            @row-del="rowDel"
            :page="page"
            @size-change="sizeChange"
            @current-change="currentChange"
            :table-loading="loading">
        </avue-crud>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading:false,
                page:{
                    pageSize: 10,
                    total:0,
                    currentPage:1
                },
                xnobj:{},
                xndata:[],
                xnoption:{
                    title:'学年列表',
                    emptyBtn:false,
                    submitBtn:false,
                    align:'center',
                    menuAlign:'center',
                    refreshBtn:false,
                    columnBtn:false,
                    border:true,
                    column:[
                        {
                            label:'学年',
                            prop:'xnd',
                            type:'select',
                            dicData:[],
                            rules: [{
                                required: true,
                                message: "请选择学年",
                                trigger: "blur"
                            }]
                        },
                        {
                            label:'学期',
                            prop:'xq',
                            type:"select",
                            dicData:[
                                {
                                    label:"1",
                                    value:"1"
                                },
                                {
                                    label:"2",
                                    value:"2"
                                }
                            ],
                            rules: [{
                                required: true,
                                message: "请选择学期",
                                trigger: "blur"
                            }]
                        },
                        {
                            label:'开始日期',
                            prop:'kssj',
                            type: "date",
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd",
                            rules: [{
                                required: true,
                                message: "请选择开始时间",
                                trigger: "change"
                            }]
                            
                        },
                        {
                            label:'结束日期',
                            prop:'jssj',
                            type: "date",
                            format: "yyyy-MM-dd",
                            valueFormat: "yyyy-MM-dd",
                            rules: [{
                                required: true,
                                message: "请选择结束时间",
                                trigger: "change"
                            }]
                        }
                    ]
                }
            }
        },
        methods: {
            // 新增编辑
            addOrEdit(row,tip){
                let dataobj={};
                for(let key of Object.keys(row)){
                    dataobj[key.toUpperCase()]=row[key];
                }
                // console.log(dataobj);
                delete dataobj.$INDEX;
                delete dataobj.ZHID;
                this.$http.post("/Xn/saveOrUpdate",null,{params:dataobj})
                .then(res=>{
                    // console.log(res);
                    this.onLoad();
                })
                .catch(error=>{
                    this.$message.error(error.msg);
                     this.$Log.capsule('学年 -'+tip+'失败', error.msg, 'danger')
                })
            },
            // 新增
            rowSave(row,done,loading){
                // console.log(row);  //添加的数据 json
                this.addOrEdit(row,'新增');
                done() //结束操作
            },
            // 编辑
            rowUpdate(row,index,done,loading){
                this.addOrEdit(row,'编辑');
                // console.log(row)
                done()
            },
            // 删除
            rowDel(row,index){
                this.$confirm('此操作将永久删除该数据, 是否继续?', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.delete("/Xn/delete",{
                        params:{
                            ID:row.id
                        }
                    }).then(res=>{
                        this.onLoad();
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                    }).catch(error=>
                        this.$Log.capsule('学年 -删除失败', error.msg, 'danger')
                    )                  
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            },
            sizeChange(val){
                this.onLoad("",val);
            },
            currentChange(val){
                this.onLoad(val);
            },
            // 分页查询
            onLoad(pageNum,pageSize){
                if(pageNum) this.page.currentPage=pageNum;
                if(pageSize) this.page.pageSize=pageSize;
                this.loading=true;
                this.$http.get("/Xn/query",{
                    params:{
                        pageNum:this.page.currentPage,
                        pageSize:this.page.pageSize
                    }
                }).then(res=>{
                    this.xndata=res.data.records;
                    this.page.total=res.data.total||res.data.records.length;
                    this.loading=false;
                })
            },
            // 学年选择
            schoolyear(){
                let date=new Date();
                let year=date.getFullYear();
                let yearArr=[];
                for(let i=1;i<=6;i++){
                    yearArr.push({label:year+'-'+(year+1),value:year+'-'+(year+1)});
                    year--;
                }
                let column = this.xnoption.column
                let index = this.findArray(column,"xnd",'prop');
                column[index].dicData=yearArr;
            }
        },
        mounted() {
            this.onLoad();
            this.schoolyear();
        },
    }
</script>

<style lang="scss" scoped>
    .school-year-setting{
        padding: 20px 20px 100px;
        background: #ffffff;
    }
</style>